import React from "react"
import styled from "styled-components"
import { theme } from "@/containers/LuckyBagNew2023/Views/mixin"
import NextImg from "@/common/components/NextImg/index"
// images
import starMask from "@/common/assets/image/lucky-bag-2023/decorationsNew/starMask.svg"
import bonusimg from "@/common/assets/image/lucky-bag-2023/bonus/Bonus2.webp"
import Decoration from "../Decoration"
import PositionAndWidth from "../PositionAndWidth"

export default function Bonus2() {
  return (
    <HeroWrapper>
      <MainWrapper>
        <NextImg src={bonusimg} />
      </MainWrapper>
      <BGWrapper>
        <BGColor></BGColor>
      </BGWrapper>
      <HeroBGWrapper>
        <NextImg src={starMask} />
      </HeroBGWrapper>
      <PositionAndWidth
        d={{ width: "8%", t: "30%", r: "20%", z: "999" }}
        m={{ width: "0%", b: "0px", r: "10%" }}
      >
        <Decoration type="starW" animation="twingle" time={3} delay={1} />
      </PositionAndWidth>
      <PositionAndWidth
        d={{ width: "6%", b: "20%", r: "25%", z: "999" }}
        m={{ width: "0%", b: "0px", r: "10%" }}
      >
        <Decoration type="starW" animation="twingle" time={2} delay={4} />
      </PositionAndWidth>
      <PositionAndWidth
        d={{ width: "5%", t: "15%", l: "50%", z: "999" }}
        m={{ width: "5%", t: "20%", l: "30%" }}
      >
        <Decoration type="starW" animation="twingle" time={4} delay={2} />
      </PositionAndWidth>
      <PositionAndWidth
        d={{ width: "12%", t: "10%", l: "0%", z: "999" }}
        m={{ width: "0%", b: "0px", r: "10%" }}
      >
        <Decoration type="starC" animation="twingle" time={2} delay={4} />
      </PositionAndWidth>
    </HeroWrapper>
  )
}

const HeroWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
const MainWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  z-index: 3;
  span {
    animation: updown 8s infinite;
  }
`

const HeroBGWrapper = styled.div`
  width: 100%;
  animation: spin 30s infinite linear;
`
const BGWrapper = styled.div`
  position: absolute;
  width: 98%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
const BGColor = styled.div`
  background-image: ${theme.StrongBgLinearTop};
  width: 100%;
  padding-bottom: 100%;
  border-radius: 50%;
`

const Start1Wrapper = styled.div`
  position: absolute;
  width: 30%;
  bottom: 0%;
  left: 0%;
  animation: twingle 15s infinite 1s;
  z-index: 333;
`
